import { defineComponent as i, createElementBlock as t, openBlock as o, mergeProps as m, unref as a, renderSlot as u, createCommentVNode as Z, createElementVNode as e } from "vue";
import { useScalarIcon as g } from "../hooks/useScalarIcon.js";
const h = { key: 0 }, f = { key: 1 }, A = { key: 2 }, L = { key: 3 }, M = { key: 4 }, k = { key: 5 }, w = {
  name: "ScalarIconCaretUpDown"
}, C = /* @__PURE__ */ i({
  ...w,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: d, weight: n } = g(s);
    return (p, l) => (o(), t("svg", m({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, a(d)), [
      u(p.$slots, "default"),
      a(n) === "bold" ? (o(), t("g", h, l[0] || (l[0] = [
        e("path", { d: "M184.49,167.51a12,12,0,0,1,0,17l-48,48a12,12,0,0,1-17,0l-48-48a12,12,0,0,1,17-17L128,207l39.51-39.52A12,12,0,0,1,184.49,167.51Zm-96-79L128,49l39.51,39.52a12,12,0,0,0,17-17l-48-48a12,12,0,0,0-17,0l-48,48a12,12,0,0,0,17,17Z" }, null, -1)
      ]))) : a(n) === "duotone" ? (o(), t("g", f, l[1] || (l[1] = [
        e("path", {
          d: "M80,176h96l-48,48ZM128,32,80,80h96Z",
          opacity: "0.2"
        }, null, -1),
        e("path", { d: "M176,168H80a8,8,0,0,0-5.66,13.66l48,48a8,8,0,0,0,11.32,0l48-48A8,8,0,0,0,176,168Zm-48,44.69L99.31,184h57.38ZM80,88h96a8,8,0,0,0,5.66-13.66l-48-48a8,8,0,0,0-11.32,0l-48,48A8,8,0,0,0,80,88Zm48-44.69L156.69,72H99.31Z" }, null, -1)
      ]))) : a(n) === "fill" ? (o(), t("g", A, l[2] || (l[2] = [
        e("path", { d: "M72.61,83.06a8,8,0,0,1,1.73-8.72l48-48a8,8,0,0,1,11.32,0l48,48A8,8,0,0,1,176,88H80A8,8,0,0,1,72.61,83.06ZM176,168H80a8,8,0,0,0-5.66,13.66l48,48a8,8,0,0,0,11.32,0l48-48A8,8,0,0,0,176,168Z" }, null, -1)
      ]))) : a(n) === "light" ? (o(), t("g", L, l[3] || (l[3] = [
        e("path", { d: "M180.24,171.76a6,6,0,0,1,0,8.48l-48,48a6,6,0,0,1-8.48,0l-48-48a6,6,0,0,1,8.48-8.48L128,215.51l43.76-43.75A6,6,0,0,1,180.24,171.76Zm-96-87.52L128,40.49l43.76,43.75a6,6,0,0,0,8.48-8.48l-48-48a6,6,0,0,0-8.48,0l-48,48a6,6,0,0,0,8.48,8.48Z" }, null, -1)
      ]))) : a(n) === "regular" ? (o(), t("g", M, l[4] || (l[4] = [
        e("path", { d: "M181.66,170.34a8,8,0,0,1,0,11.32l-48,48a8,8,0,0,1-11.32,0l-48-48a8,8,0,0,1,11.32-11.32L128,212.69l42.34-42.35A8,8,0,0,1,181.66,170.34Zm-96-84.68L128,43.31l42.34,42.35a8,8,0,0,0,11.32-11.32l-48-48a8,8,0,0,0-11.32,0l-48,48A8,8,0,0,0,85.66,85.66Z" }, null, -1)
      ]))) : a(n) === "thin" ? (o(), t("g", k, l[5] || (l[5] = [
        e("path", { d: "M178.83,173.17a4,4,0,0,1,0,5.66l-48,48a4,4,0,0,1-5.66,0l-48-48a4,4,0,0,1,5.66-5.66L128,218.34l45.17-45.17A4,4,0,0,1,178.83,173.17Zm-96-90.34L128,37.66l45.17,45.17a4,4,0,1,0,5.66-5.66l-48-48a4,4,0,0,0-5.66,0l-48,48a4,4,0,0,0,5.66,5.66Z" }, null, -1)
      ]))) : Z("", !0)
    ], 16));
  }
});
export {
  C as default
};
